// 订单管理-->库房信息-->中英文
export const warehouseLocale = {
    'zhCN': {
        public: {
            whetherStart: '确定启用？',
            whetherStop: '确定停用？',
            whetherStopExistenceRelationship: '库房存在货主产品库房关联关系不能停用！'
        },
        warehouse: {
            warehouseName: '库房名称',
            warehouseShortName: '库房简称',
            address: '库房地址',
            warehouseManagement: '库房维护',
            warehouseDetail: '库房明细',

            // 验证相关
            warehouseNameEmpty: '库房名称不能为空',
            warehouseNameLength: '库房名称过长',
            warehouseShortNameEmpty: '库房简称不能为空',
            warehouseShortNameLength: '库房简称过长',
            warehouseAddressNameEmpty: '库房地址不能为空',
            warehouseAddressLength: '库房地址过长'
        }
    },
    'enUS': {
        public: {
            whetherStart: 'Are you sure to enable?',
            whetherStop: 'Determined to deactivate?',
            whetherStopExistenceRelationship: 'The warehouse owner has a warehouse product relationship that cannot be deactivated!'
        },
        warehouse: {
            warehouseName: 'Warehouse  Name',
            warehouseShortName: 'Warehouse Short Name',
            address: 'Warehouse address',
            warehouseManagement: 'Warehouse maintenance',
            warehouseDetail: 'Warehouse details',

            // 验证相关
            warehouseNameEmpty: 'The warehouse name cannot be empty',
            warehouseNameLength: 'The name of the storehouse is too long',
            warehouseShortNameEmpty: 'The Warehouse Short Name cannot be empty',
            warehouseShortNameLength: 'The warehouse is abbreviated too long',
            warehouseAddressNameEmpty: 'The warehouse address cannot be empty',
            warehouseAddressLength: 'The warehouse address is too long'
        }
    }
}
export default warehouseLocale



// WEBPACK FOOTER //
// ./src/locale/modules/warehouseLocale.js